import { AfterViewInit, Component, computed, ElementRef, inject, OnInit, output, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonButtonRowWidget, CommonDateTimeFieldWidget, CommonMessageWidget, CommonSelectFieldWidget, CommonTextFieldWidget, CommonUrlFieldWidget } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { EventTypeId, StaffData } from '@interfaces';
import { StaffSelectorWidget } from 'ui/widget/staff-selector';
import { AppService } from '../../../../../services';
import { EventAddFormService, EventAddFormValue } from './event-add-form.service';
import { VenueButtonPart } from "../../venue/venue-button/venue-button.part";


@Component({
	selector: 'event-dialog-add-part',
	standalone: true,
	imports: [
		CommonTextFieldWidget,
		CommonUrlFieldWidget,
		CommonButtonRowWidget,
		CommonMessageWidget,
		CommonDateTimeFieldWidget,
		CommonSelectFieldWidget,
		StaffSelectorWidget,
		VenueButtonPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './event-add.part.html'
})

export class EventDialogAddPart implements OnInit, AfterViewInit {

	public app = inject(AppService);

	public form = new EventAddFormService();
	public sessionEventTypeId = EventTypeId.AccSession;
	public eventFormAddBtn = viewChild.required<ElementRef<HTMLButtonElement>>('eventFormAddBtn');
	public staffData = signal<StaffData[]>([]);
	public data = computed(() => this.form.eventAddDialogDataService.data());

	public closeDialog = output();

	async ngOnInit() {
		this.staffData.set(this.app.data().staff);
	}

	ngAfterViewInit() {
		this.form.form.setSubmitButton(
			this.eventFormAddBtn(),
			async (values: EventAddFormValue, changed: string[]) => {
				console.log('Submitting event edit form with values:', values, 'and changed fields:', changed);
				const data = this.form.eventAddDialogDataService.data();
				if (data) {
					if (values.toolSelection === 'automatic' || !data.eventType.toolNameLabelKey) {
						values.toolStartUTC = values.startUTC - (1 * 24 * 60 * 60);
						values.toolEndUTC = values.endUTC + (1 * 24 * 60 * 60);
					}

					if (!values.toolStartUTC || !values.toolEndUTC) {
						throw new Error('Tool start and end dates are missing');
					}

					const venueId = this.form.venueValues()?.venueId;
					if (values.venue === 'In Person' && !venueId) {
						throw new Error('Venue must be selected for In Person events');
					}

					await this.form.eventAddDialogDataService.addEvent({
						eventTypeId: data.eventType.eventTypeId,
						languageId: data.languageId,
						accId: data.acc?.accId,
						startUTC: values.startUTC,
						endUTC: values.endUTC,
						toolStartUTC: values.toolStartUTC,
						toolEndUTC: values.toolEndUTC,
						link: values.link,
						publicNotes: values.publicNotes,
						hostPersonId: this.form.hostPerson()!.personId,
						venueId
					});

					this.closeDialog.emit();
				}
			}
		);
	}


	/**
	* Event raised when a venue is selected from the venue dialog.
	*/
	public onVenueSelection(venue: { venueId: number, displayedName: string }) {
		this.form.venueValues.set({ venueId: venue.venueId, displayName: venue.displayedName });
	}
}